import { useTheme } from '@mui/material/styles';
import dayjs from 'dayjs';
import React from 'react';

import { formatDate } from '@utils/format';

import {
  DateSection,
  Day,
  Information,
  Location,
  Month,
  Name,
  Time,
  UpcomingAppointmentCardStyle,
} from './UpcomingAppointmentCard.style';

export default function UpcomingAppointmentCard({
  date = new Date(),
  title = '',
  subtitle = '',
  fullWidth = false,
  onClick,
  colour,
  dateComponents,
}: {
  date?: Date | string | null;
  dateComponents?: {
    month?: string;
    day?: string;
    time?: string;
  };
  title?: string | null;
  subtitle?: string | null;
  fullWidth?: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  colour?: string;
}) {
  function handleClick(event: React.MouseEvent<HTMLDivElement>) {
    if (onClick) {
      onClick(event);
    }
  }

  const { palette } = useTheme();

  const resolvedColor = colour ?? palette.secondary.main;

  const showTime =
    dayjs(date).toDate().getTime() !==
    dayjs(date).startOf('day').toDate().getTime();

  let month = dateComponents?.month;
  let day = dateComponents?.day;
  let time = dateComponents?.time;

  if (date && !(day || month)) {
    month = formatDate({ date, formatter: 'MMM' });
    day = formatDate({ date, formatter: 'DD' });
    time = formatDate({ date, formatter: 'hh:mm a' });
  }

  return (
    <UpcomingAppointmentCardStyle fullWidth={fullWidth} onClick={handleClick}>
      <DateSection colour={resolvedColor}>
        <Month data-testid="appt-card-month">{month}</Month>
        <Day data-testid="appt-card-day">{day}</Day>
      </DateSection>
      <Information>
        <Time data-testid="appt-card-time">{showTime ? time : ''}</Time>
        <Name data-testid="appt-card-name">{title}</Name>
        <Location data-testid="appt-card-location">{subtitle}</Location>
      </Information>
    </UpcomingAppointmentCardStyle>
  );
}
